// extracted by mini-css-extract-plugin
export default {"SubSection":"WildlifeManagement-PDF-style_SubSection__BFpnB","Disclaimer":"WildlifeManagement-PDF-style_Disclaimer__zvqZP","Bordered":"WildlifeManagement-PDF-style_Bordered__X2iLd"};